import ViewClinic from './ViewClinic';

export default ViewClinic;
